import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SortArrowDown } from "../Assets/svgs/sortArrowDown";
import { CallScheduleIcon } from "../Assets/svgs/CallScheduleIcon";
import Tooltip from "@mui/material/Tooltip";
import CallInstantIcon from "../Assets/svgs/CallInstantIcon";
import { RoundArrowIcon } from "../Assets/svgs/RightArrowIcon";
import TableActionMenu from "./TableActionMenu";
import CallBlueIcon from "../Assets/svgs/CallBlueIcon";
import EmailBlueIcon from "../Assets/svgs/EmailBlueIcon";

export const Table = (props) => {
  const navigate = useNavigate();
  const { data, actionMenus } = props;
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [removeModel, setRemoveModel] = useState(false);
  const [rowData, setRowData] = useState(null);

  const sortedData = useMemo(() => {
    let sortableData = Array.isArray(data) ? [...data] : [];
    if (sortConfig.key) {
      sortableData.sort((a, b) => {
        if (
          a[sortConfig.key].toString().toLowerCase() <
          b[sortConfig.key].toString().toLowerCase()
        ) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (
          a[sortConfig.key].toString().toLowerCase() >
          b[sortConfig.key].toString().toLowerCase()
        ) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [data, sortConfig]);

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  return (
    <div className="tableContainer">
      <table className="table">
        <thead>
          <tr>
            {props.hasCheckBox ? (
              <th>
                <div className="sortingDiv">
                  <div className="form__checkbox form__checkbox--gray">
                    <div className="form__checkbox__option">
                      <input
                        type="checkbox"
                        id="selectAll"
                        readOnly
                        checked={props?.allChecked ?? false}
                        onClick={() => props.hasCheckBox("all")}
                        className="form__checkbox__input"
                      />
                      <label className="form__checkbox__label" for="selectAll">
                        &nbsp;
                      </label>
                    </div>
                  </div>
                </div>
              </th>
            ) : (
              ""
            )}
            {props.columns
              ? props.columns.map((column, index) => {
                  return (
                    <th key={`${column?.key}-${index}`}>
                      <div className="sortingDiv">
                        {column.label}
                        <span
                          className="sortingDiv__icon"
                          onClick={() => requestSort(column.key)}
                        >
                          <SortArrowDown />
                        </span>
                      </div>
                    </th>
                  );
                })
              : ""}
            {props.hasAction === "true" ? (
              <th>
                <div className="actions flex--center">Action</div>
              </th>
            ) : (
              ""
            )}
          </tr>
        </thead>
        <tbody>
          {sortedData && sortedData.length > 0 ? (
            sortedData.map((rowItem, rowIndex) => {
              return (
                <tr key={`${rowItem?.id}-${rowIndex}-${rowItem?.checkedRow}`}>
                  {props.hasCheckBox ? (
                    <th>
                      <div className="sortingDiv">
                        <div className="form__checkbox form__checkbox--gray">
                          <div className="form__checkbox__option">
                            <input
                              type="checkbox"
                              id="selectAll"
                              readOnly
                              checked={rowItem?.checkedRow ?? false}
                              onClick={() => props.hasCheckBox(rowItem)}
                              className="form__checkbox__input"
                            />
                            <label
                              className="form__checkbox__label"
                              for="selectAll"
                            >
                              &nbsp;
                            </label>
                          </div>
                        </div>
                      </div>
                    </th>
                  ) : (
                    ""
                  )}
                  {props.columns
                    ? props.columns.map((col, colIndex) => (
                        <td
                          key={`${rowItem?.id}-${col?.key}-${colIndex}-${rowIndex}`}
                        >
                          {col.className === "profile__link" ? (
                            <div className={"profile"}>
                              {col?.avatarKey && rowItem[col?.avatarKey] ? (
                                <div className="profile__image">
                                  <img src={rowItem[col?.avatarKey]} alt="" />
                                </div>
                              ) : (
                                <div className="profile__initials">
                                  {String(rowItem[col.key])[0]}
                                </div>
                              )}
                              <span
                                onClick={() =>
                                  props?.onClickLink &&
                                  props?.onClickLink(rowItem)
                                }
                                className="profile__name profile__name--underline"
                              >
                                {rowItem[col.key]}
                                <RoundArrowIcon />
                              </span>
                            </div>
                          ) : col.className === "profile" ? (
                            <div className={col.className}>
                              {" "}
                              {col?.avatarKey && rowItem[col?.avatarKey] ? (
                                <div className="profile__image">
                                  <img src={rowItem[col?.avatarKey]} alt="" />
                                </div>
                              ) : (
                                <div className="profile__initials">
                                  {String(rowItem[col.key])[0]}
                                </div>
                              )}
                              <span className="profile__name">
                                {rowItem[col.key]}
                              </span>{" "}
                            </div>
                          ) : col.className === "switchBtn" ? (
                            <div className="form__switchBtn">
                              <div className="form__switchBtn__option">
                                <div className="switchBtn">
                                  <input
                                    type="checkbox"
                                    className="toggle"
                                    id={`toggle-${col?.key}-${
                                      col?.id ? col?.id : colIndex
                                    }-${
                                      rowItem[col.key]?.id
                                        ? rowItem[col.key]?.id
                                        : rowIndex
                                    }`}
                                    checked={rowItem[col?.key] ?? false}
                                    onChange={(e) => {
                                      if (
                                        typeof col?.onSwitchValueChanged ==
                                          "function" &&
                                        (col?.disabledKey
                                          ? Boolean(rowItem[col?.disabledKey])
                                          : true)
                                      ) {
                                        col?.onSwitchValueChanged(
                                          e.target.checked,
                                          rowItem
                                        );
                                      }
                                    }}
                                  />
                                  <label
                                    for={`toggle-${col?.key}-${
                                      col?.id ? col?.id : colIndex
                                    }-${
                                      rowItem[col.key]?.id
                                        ? rowItem[col.key]?.id
                                        : rowIndex
                                    }`}
                                  >
                                    <span className="on">ON</span>
                                    <span className="off">OFF</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          ) : col.className === "cellText" ? (
                            <div className="cellText">
                              <span className="cellText__dark">
                                {rowItem[col.key]}
                              </span>
                            </div>
                          ) : col.className === "cellText_cardNumber" ? (
                            <div className="cellText">
                              <span
                                className="cellText__dark"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                ****-****-****-<span>{rowItem[col.key]}</span>
                              </span>
                            </div>
                          ) : col.className === "statusChip" ? (
                            <div className="actions">
                              <button
                                class={`btn ${
                                  rowItem[col.key] == col?.successChip
                                    ? "btn--statusSuccess"
                                    : rowItem[col.key] == col?.endChip
                                    ? "btn--statusEnd"
                                    : rowItem[col.key] == col?.failedChip
                                    ? "btn--statusFailed"
                                    : "btn--statusPending"
                                }`}
                              >
                                {rowItem[col.key]}
                              </button>
                            </div>
                          ) : col.className === "infoChip" ? (
                            <div className="actions">
                              <button className="btn btn--phoneCall">
                                {rowItem[col.key] == "Call" ||
                                rowItem[col.key] == "In-Bound Call" ? (
                                  <CallBlueIcon />
                                ) : (
                                  <EmailBlueIcon />
                                )}
                                {rowItem[col.key]}
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </td>
                      ))
                    : ""}
                  {props.hasAction === "true" &&
                  (props?.isShowActionKey
                    ? rowItem[props?.isShowActionKey]
                    : true) ? (
                    <td>
                      <div className="actions flex--center">
                        {props.onView ? (
                          <button
                            className="btn p_0 border_0"
                            onClick={() => props.onView(rowItem)}
                          >
                            <svg
                              width="24"
                              height="18"
                              viewBox="0 0 24 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 9C1 9 5 1.5 12 1.5C19 1.5 23 9 23 9C23 9 19 16.5 12 16.5C5 16.5 1 9 1 9Z"
                                stroke="#8b58f1"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M12 11.8125C13.6569 11.8125 15 10.5533 15 9C15 7.4467 13.6569 6.1875 12 6.1875C10.3431 6.1875 9 7.4467 9 9C9 10.5533 10.3431 11.8125 12 11.8125Z"
                                stroke="#8b58f1"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        ) : (
                          ""
                        )}
                        {props?.onCallInstant ? (
                          <Tooltip title="Call Instantly" placement="top" arrow>
                            <button
                              className="btn p_0 border_0"
                              onClick={() => {
                                props.onCallInstant(rowItem);
                              }}
                            >
                              <CallInstantIcon />
                            </button>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                        {props.onScheduleCall ? (
                          <Tooltip
                            title="Schedule a call"
                            placement="top"
                            arrow
                          >
                            <button
                              className="btn p_0 border_0"
                              onClick={() => {
                                props.onScheduleCall(rowItem);
                              }}
                            >
                              <CallScheduleIcon />
                              {/* <span className="tooltiptext">Schedule a call</span> */}
                            </button>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                        {props.onManagePlan ? (
                          <button
                            className="btn btn__primary btn__outlined"
                            onClick={() => {
                              props.onManagePlan(rowItem);
                            }}
                          >
                            Manage Plan
                          </button>
                        ) : (
                          ""
                        )}
                        {props.onEdit ? (
                          <Tooltip title="Edit" placement="top" arrow>
                            <button
                              className="btn p_0 border_0"
                              onClick={() => {
                                props.onEdit(rowItem);
                              }}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_131_3877)">
                                  <path
                                    d="M14.1667 2.49993C14.3856 2.28106 14.6455 2.10744 14.9314 1.98899C15.2174 1.87054 15.5239 1.80957 15.8334 1.80957C16.1429 1.80957 16.4494 1.87054 16.7354 1.98899C17.0214 2.10744 17.2812 2.28106 17.5001 2.49993C17.719 2.7188 17.8926 2.97863 18.011 3.2646C18.1295 3.55057 18.1904 3.85706 18.1904 4.16659C18.1904 4.47612 18.1295 4.78262 18.011 5.06859C17.8926 5.35455 17.719 5.61439 17.5001 5.83326L6.25008 17.0833L1.66675 18.3333L2.91675 13.7499L14.1667 2.49993Z"
                                    stroke="#0F172A"
                                    stroke-width="1.66667"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_131_3877">
                                    <rect width="20" height="20" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </button>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                        {props.onDelete ? (
                          <Tooltip title="Delete" placement="top" arrow>
                            <button
                              className="btn p_0 border_0"
                              onClick={() => {
                                props.onDelete(rowItem);
                              }}
                            >
                              <svg
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.5 4.99984H3.16667M3.16667 4.99984H16.5M3.16667 4.99984V16.6665C3.16667 17.1085 3.34226 17.5325 3.65482 17.845C3.96738 18.1576 4.39131 18.3332 4.83333 18.3332H13.1667C13.6087 18.3332 14.0326 18.1576 14.3452 17.845C14.6577 17.5325 14.8333 17.1085 14.8333 16.6665V4.99984H3.16667ZM5.66667 4.99984V3.33317C5.66667 2.89114 5.84226 2.46722 6.15482 2.15466C6.46738 1.8421 6.89131 1.6665 7.33333 1.6665H10.6667C11.1087 1.6665 11.5326 1.8421 11.8452 2.15466C12.1577 2.46722 12.3333 2.89114 12.3333 3.33317V4.99984M7.33333 9.1665V14.1665M10.6667 9.1665V14.1665"
                                  stroke="#D4001C"
                                  stroke-width="1.66667"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </button>
                          </Tooltip>
                        ) : (
                          ""
                        )}
                        {props.onViewTransactions ? (
                          <button
                            className="btn btn__primary btn__outlined"
                            onClick={() => {
                              props.onViewTransactions(rowItem);
                            }}
                          >
                            {props?.actionText ?? "View Transaction"}
                          </button>
                        ) : (
                          ""
                        )}
                        {props?.isShowActionMenu &&
                        (props?.showKebabKey
                          ? rowItem[props?.showKebabKey]
                          : true) &&
                        Array.isArray(actionMenus) &&
                        actionMenus?.length ? (
                          <TableActionMenu
                            rowItem={rowItem}
                            actionMenus={actionMenus}
                          />
                        ) : null}
                      </div>
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan={
                  props.hasAction === "true" || props?.isShowActionMenu
                    ? props?.hasCheckBox
                      ? props.columns.length + 2
                      : props.columns.length + 1
                    : props.columns.length
                }
              >
                <div className="no-data">
                  {props?.noDataMsg ? props?.noDataMsg : "No Results Found!"}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
